import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import { withSnackbar } from 'notistack';
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppAnimate from "../../../components/AppAnimate";
import AppCard from "../../../components/layouts/components/AppCard";
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {setStore} from "trim-redux";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import FestivalItem from "./FestivalItem";
import Alert from "@material-ui/lab/Alert/Alert";

class ViewFestivals extends React.Component {
    state = {
        festivals:[],
        loading:true,
    }
    classes = this.props.classes;

    componentDidMount() {
        this.loadData();
    }

    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/festivals/getAll`, config)
                .then(response => {
                    this.setState({
                        festivals:response.data,
                        loading:false,
                    })

                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    render(){
        let {loading,festivals} = this.state;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.activeFestivals}>
                <Grid container spacing={2} >
                    <Grid item xs={12}>
                        <AppCard
                            title={Translate.activeFestivals}
                            action={
                                <BreadCrumbs singleLevel firstText={Translate.activeFestivals}/>
                            }>
                            {
                                !!loading ? <AppCardLoaderFields/> :
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Alert severity="info">
                                                {Translate.festivalsHelp}
                                            </Alert>
                                        </Grid>
                                        {
                                            festivals.map((festival,index) => (
                                                <Grid item xs={12} md={4}>
                                                    <FestivalItem key={index} festival={festival}/>
                                                </Grid>
                                            ))
                                        }
                                    </Grid>
                            }
                        </AppCard>
                    </Grid>
                </Grid>
            </AppAnimate>
        );
    }
}
export default withSnackbar(withStyles(Styles)(ViewFestivals));
